import { uniq } from "lodash";
import moment from "moment";
import { batch } from "react-redux";

import {
  setIsPauseHandled,
  setRunningMethod,
  setShowPauseToRefillModal,
} from "@/actions/autoProfileStateAction";
import {
  isShowRecoveryLoading,
  showLoading,
  updateLoading,
} from "@/actions/loadingActions";
import {
  IsShowManualControlAvailablePopUp,
  IsShowManualControlPopUp,
  updateIsHoldToRunActive,
  updateManualControlStartVolume,
  updateManualControlState,
} from "@/actions/manualControlActions";
import { hidePopUp, showModal, showPopUp } from "@/actions/modalActions";
import {
  setDeltaTime,
  setScheduleId,
  setScheduleRun,
  setScheduleType,
  setShowScheduleRunModal,
  setStartTime,
} from "@/actions/schedulerStateAction";
import {
  isCompleteFill,
  isFinishRecovery,
  IsFromStopProfile,
  IsRecoveryClicked,
  IsRecoveryFromErrorProfile,
  setAdvSetupSelected,
  setCurrentBuffer,
  setCurrentVolume,
  setDisabledTopButtonProp,
  setInvalidAutoProfileParams,
  setRequireRefill,
  showAlert,
  updateActiveMenu,
  updateAutoProfileDiafiltrationMode,
  updateAutoProfileSetupMode,
  updateCurrentAdvSetupParam,
  updateCurrentIsMoreThan50ml,
  updateCurrentProfileParam,
  updateShowRefillBuffer,
  updateStatus,
  updateStoppingFromButton,
} from "@/actions/setupActions";
import {
  postNewStartConcentrator,
  postPauseConcentrator,
  postResumeConcentrator,
  postStopConcentrator,
  postStopMixingConcentrator,
} from "@/api/concentratorApi";
import {
  getDelayProfile,
  postDelayProfile,
  removeDelayProfile,
} from "@/api/delayProfileApi";
import { getStatus } from "@/api/deviceApi";
import { PostRequest } from "@/api/request";
import {
  AutoProfileConstants,
  BufferExchangesStateMapper,
  Concentrate2TubesStateMapper,
  ConcentrateStateMapper,
  MembraneCutOff,
  RecoveryOfLiquidAction,
  RecoveryOfLiquidMode,
  StopEnum,
} from "@/constants/autoProfileEnum";
import {
  AutoProfileSetupMode,
  ConicalOptionsV2,
  ConicalType,
} from "@/constants/autoProfileOption";
import {
  CONICAL_VOLUME,
  CURRENT_BUFFER_EXCHANGE_VOL_THRESHOLD,
  RECOVERY_FINAL_VOL_THRESHOLD,
} from "@/constants/configurations";
import { VERSION_2 } from "@/constants/constant";
import { MANUAL_CONTROL_ENUM, SCHEDULE_PROFILE } from "@/constants/enums";
import {
  AUTO_RECOVERY,
  BUFFER_EXCHANGE,
  CONC_TWO_TUBES,
  CONCENTRATE,
  CURRENT_BUFFER_VOLUME,
  EXCHANGE_SIZE,
  FINAL_VOLUME,
  STARTING_VOLUME,
  STEP_SIZE,
  VOLUME_TO_START_AT,
} from "@/constants/fieldNames";
import { ConicalVolume } from "@/constants/jsonKeys";
import * as APPDATA from "@/constants/pcConstAppData";
import {
  ManualControlEventTopMenu,
  RecoveryOfLiquidEvent,
  RunAutoProfileEvent,
  StopEvent,
} from "@/constants/pubSubEnum";
import { PreCheckRunningProfileEvent } from "@/contents/autoProfile/runProfileValidator/PreCheckRunningProfile";
import {
  createNewJsonObject,
  isAllAutoProfileParamFilled,
  navigateTo,
} from "@/libs/appHelper";
import {
  generateProfileConfigModel,
  getAutoProfileUpdateStatusModel,
  getInvalidFieldBufferExchange,
  getInvalidFieldConc,
  getInvalidFieldConc2Tubes,
  getLimitFinalVolBufferExchange,
  getLimitFinalVolConc,
  getLimitFinalVolConc2Tubes,
  parseNumberParam,
  validateBufferVolBufferExchange,
} from "@/libs/autoProfileHelper";
import { formatMessage } from "@/libs/intlHelper";
import { objMapper, parseValueToString } from "@/libs/objectHelper";
import { eventBusObject } from "@/observers/eventBus";

import {
  PostRecoveryOfLiquidManual,
  PostStopNormalConcentration,
  PostStopRecovery,
} from "./fetchManualControl";
import { startManualControl } from "./manualControlBusiness";

export const updateProfileParamByName =
  (name, value) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentProfileParams } = setupStore;
    const _currentProfileParams = { ...currentProfileParams };
    // const body = {[name]: value};
    if (value) {
      _currentProfileParams[name] = value?.toString();
    }
    dispatch(updateCurrentProfileParam(_currentProfileParams));
    // disable run after all field is valid

    if (isAllAutoProfileParamFilled(_currentProfileParams) === true) {
      dispatch(isCompleteFill(true));
    } else {
      dispatch(isCompleteFill(false));
    }
  };

export const bulkUpdateProfileParamByName =
  (data = {}) =>
  (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentProfileParams } = setupStore;

    const _currentProfileParams = parseValueToString({
      ...currentProfileParams,
      ...data,
    });

    batch(() => {
      dispatch(updateCurrentProfileParam(_currentProfileParams));

      if (isAllAutoProfileParamFilled(_currentProfileParams) === true) {
        dispatch(isCompleteFill(true));
      } else {
        dispatch(isCompleteFill(false));
      }
    });
  };

export const removeInvalidAutoProfileParamByName =
  (names) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { invalidAutoProfileParams } = setupStore;

    dispatch(
      setInvalidAutoProfileParams(
        [...invalidAutoProfileParams].filter((e) => !names.includes(e))
      )
    );
  };

export const removeInvalidAutoProfileParam = () => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { invalidAutoProfileParams } = setupStore;

  dispatch(
    setInvalidAutoProfileParams(
      uniq(
        [...invalidAutoProfileParams].filter(
          (e) => e === CURRENT_BUFFER_VOLUME || e === AUTO_RECOVERY
        )
      )
    )
  );
};

export const updateProfileAdvSetupParam =
  (id, name) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentProfileParams } = setupStore;
    const _currentProfileParams = { ...currentProfileParams };
    if (id !== null && name !== null) {
      _currentProfileParams[APPDATA.KEY.IdAdvSetup] = id.toString();
      _currentProfileParams[APPDATA.KEY.AdvancedSetupName] = name.toString();
    }
    dispatch(updateCurrentProfileParam(_currentProfileParams));
  };

export const validateCurrBufferVolRefill =
  (isValid) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { invalidAutoProfileParams } = setupStore;

    let result = [...invalidAutoProfileParams];

    if (isValid) result.push(APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME);
    else
      result = result.filter(
        (e) => e !== APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME
      );

    dispatch(setInvalidAutoProfileParams(result));
  };

export const handleWarningInvalidParamClick = (id) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { autoProfileSetupMode } = setupStore;

  switch (id) {
    case autoProfileSetupMode + APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.bufferRefillRequired.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
      break;
    case BUFFER_EXCHANGE + APPDATA.FIELD_NAME.STARTING_VOLUME:
    case CONCENTRATE + APPDATA.FIELD_NAME.STARTING_VOLUME:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.invalidStartingVolume.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
      break;
    case CONC_TWO_TUBES + APPDATA.FIELD_NAME.STARTING_VOLUME_FIRST_TUBE:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.concentrateTwoTubes.invalidStartingVolume.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
      break;
    case BUFFER_EXCHANGE + APPDATA.FIELD_NAME.FINAL_VOLUME:
    case CONCENTRATE + APPDATA.FIELD_NAME.FINAL_VOLUME:
    case CONC_TWO_TUBES + APPDATA.FIELD_NAME.FINAL_VOLUME:
      dispatch(finalVolumeExclamationWarning());

      break;
    case BUFFER_EXCHANGE + APPDATA.FIELD_NAME.VOLUME_TO_START_AT:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStartExchange.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
      break;
    case BUFFER_EXCHANGE + APPDATA.FIELD_NAME.EXCHANGE_SIZE:
    case BUFFER_EXCHANGE + APPDATA.FIELD_NAME.STEP_SIZE:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStepSize.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
      break;

    default:
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.invalidStartingAndFinalVol.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING, // APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER
        })
      );
      break;
  }
};

export const finalVolumeExclamationWarning = () => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const {
    invalidAutoProfileParams,
    currentProfileParams,
    autoProfileSetupMode,
  } = setupStore;

  const startingVolume = currentProfileParams[APPDATA.KEY.StartingVolume];
  const conicalVolume = currentProfileParams[APPDATA.KEY.ConicalVolume];
  const tube1 = currentProfileParams[APPDATA.KEY.StartingVolume];
  const tube2 = currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube];
  const finalVolume = currentProfileParams[APPDATA.KEY.FinalVolume];

  let minValue;
  let maxValue;

  switch (autoProfileSetupMode) {
    case AutoProfileSetupMode[0]: {
      const { max, min } = getLimitFinalVolConc(startingVolume, conicalVolume);
      maxValue = max;
      minValue = min;
      break;
    }
    case AutoProfileSetupMode[1]: {
      const { max, min } = getLimitFinalVolConc2Tubes(
        tube1,
        tube2,
        conicalVolume
      );

      maxValue = max;
      minValue = min;
      break;
    }
    case AutoProfileSetupMode[2]: {
      const { max, min } = getLimitFinalVolBufferExchange(
        startingVolume,
        conicalVolume
      );
      maxValue = max;
      minValue = min;
      break;
    }
    default:
      return;
  }

  if (invalidAutoProfileParams.includes(APPDATA.FIELD_NAME.FINAL_VOLUME)) {
    if (finalVolume < conicalVolume) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage(
            {
              id: "toast.autoProfile.finalVolume.exclamation",
            },
            { minValue, maxValue }
          ),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
    } else {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.autoProfile.invalidFinalVolume.message",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
        })
      );
    }
  } else if (
    invalidAutoProfileParams.includes(APPDATA.FIELD_NAME.AUTO_RECOVERY)
  ) {
    dispatch(
      showAlert({
        alertShow: true,
        alertText: formatMessage({
          id: "toast.autoProfile.autoRecovery.finalVolume.message",
        }),
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
      })
    );
  }
};

// #region SETUP AUTO PROFILE

export const initAutoProfileSetup = (initialState) => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const {
    currentProfileParams,
    currentAdvSetupParams,
    defaultConfigAdvSetupParams,
    deviceVersion,
    defaultConfigParams,
    autoProfileSetupMode,
  } = setupStore;

  const configParam = initialState;

  if (!defaultConfigParams) {
    navigateTo(APPDATA.HOME_SCREEN_ADDRESS);
    return configParam;
  }

  switch (autoProfileSetupMode) {
    case AutoProfileSetupMode[0]:
      configParam[autoProfileSetupMode] = objMapper(
        currentProfileParams,
        ConcentrateStateMapper
      );
      break;
    case AutoProfileSetupMode[1]:
      configParam[autoProfileSetupMode] = objMapper(
        currentProfileParams,
        Concentrate2TubesStateMapper
      );

      break;
    case AutoProfileSetupMode[2]:
      configParam[autoProfileSetupMode] = objMapper(
        currentProfileParams,
        BufferExchangesStateMapper
      );
      break;

    default:
      break;
  }

  batch(() => {
    if (deviceVersion === VERSION_2)
      dispatch(changeConical(ConicalType[50].toString()));
    if (currentAdvSetupParams === undefined)
      dispatch(updateCurrentAdvSetupParam(defaultConfigAdvSetupParams));

    dispatch(isCompleteFill(isAllAutoProfileParamFilled(currentProfileParams)));
    dispatch(changeMethodAutoProfile(autoProfileSetupMode, false));
  });

  return configParam;
};

export const doRunAutoProfile = () => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const {
    currentProfileParams,
    currentAdvSetupParams,
    invalidAutoProfileParams,
  } = setupStore;
  const param = {
    [APPDATA.KEY.ProfileRunnig]: currentProfileParams,
  };
  const bus = eventBusObject();

  // setup adv setup
  let advSetup = {
    id: APPDATA.EMPTY_FIELD,
    name: "DEFAULT SETUP",
  };

  if (currentAdvSetupParams)
    advSetup = {
      id: currentAdvSetupParams.Id,
      name: currentAdvSetupParams.Name,
    };

  batch(() => {
    // NOTE: remove all invalid fields except current buffer volume on buffer exchange
    dispatch(
      setInvalidAutoProfileParams(
        invalidAutoProfileParams.filter(
          (e) => e === CURRENT_BUFFER_VOLUME || e === AUTO_RECOVERY
        )
      )
    );
    dispatch(updateProfileAdvSetupParam(advSetup.id, advSetup.name));
    dispatch(
      updateManualControlState(
        MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL
      )
    );
    bus.publish(RunAutoProfileEvent.AUTORUN, param);
  });
};

export const validateAutoProfileParams = () => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const {
    autoProfileSetupMode,
    currentProfileParams,
    currentAdvSetupParams,
    advSetupSelected,
  } = setupStore;
  const conicalVolume = parseFloat(
    currentProfileParams[APPDATA.KEY.ConicalVolume]
  );
  const startingVolume = parseFloat(
    currentProfileParams[APPDATA.KEY.StartingVolume]
  );
  const startingVolume2ndTube = parseFloat(
    currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube]
  );
  const finalVolume = parseFloat(currentProfileParams[APPDATA.KEY.FinalVolume]);
  const volumeToStartAt = parseFloat(
    currentProfileParams[APPDATA.KEY.VolumeToStartAt]
  );
  const stepSizeVolume = parseFloat(
    currentProfileParams[APPDATA.KEY.StepSizeVolume]
  );
  const bufferVolumeToUse = parseFloat(
    currentProfileParams[APPDATA.KEY.BufferVolumeToUse]
  );
  const safetyThreshold = parseFloat(
    currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup
      ?.ManualControlThreshold
  );

  const autoRecovery =
    advSetupSelected?.ConfigAdvSetup?.GeneralAdvSetup?.AutoRecoveryFlag;

  let alertText = "";
  let alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING;
  let warningList = [];
  let isShowSafetyThresholdWarning = false;

  switch (autoProfileSetupMode) {
    case CONCENTRATE: {
      const invalidFields = getInvalidFieldConc(
        startingVolume,
        finalVolume,
        autoRecovery,
        conicalVolume
      );

      warningList = warningList.concat(invalidFields);

      if (warningList.length) {
        if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
          alertText = formatMessage({
            id: "toast.autoProfile.finalVolumeAutoRecovery.error",
          });
          alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
        } else {
          alertText = formatMessage({
            id: "toast.autoProfile.invalidStartingAndFinalVol.message",
          });
        }
      }

      break;
    }
    case CONC_TWO_TUBES: {
      const invalidFields = getInvalidFieldConc2Tubes(
        startingVolume,
        startingVolume2ndTube,
        finalVolume,
        autoRecovery,
        conicalVolume
      );

      warningList = warningList.concat(invalidFields);

      if (warningList.length) {
        if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
          alertText = formatMessage({
            id: "toast.autoProfile.finalVolumeAutoRecovery.error",
          });
          alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
        } else {
          alertText = formatMessage({
            id: "toast.autoProfile.concentrateTwoTubes.invalidStartingAndFinalVol.message",
          });
        }
      }

      break;
    }
    case BUFFER_EXCHANGE: {
      const invalidFields = getInvalidFieldBufferExchange(
        startingVolume,
        finalVolume,
        volumeToStartAt,
        stepSizeVolume,
        bufferVolumeToUse,
        autoRecovery,
        conicalVolume
      );

      warningList = warningList.concat(invalidFields);

      if (warningList.some((e) => [STARTING_VOLUME, FINAL_VOLUME].includes(e)))
        alertText = formatMessage({
          id: "toast.autoProfile.invalidStartingAndFinalVol.message",
        });
      else if (warningList.some((e) => [STEP_SIZE, EXCHANGE_SIZE].includes(e)))
        alertText = formatMessage({
          id: "toast.autoProfile.bufferExchange.invalidStepSize.message",
        });
      else if (warningList.some((e) => [VOLUME_TO_START_AT].includes(e)))
        alertText = formatMessage({
          id: "toast.autoProfile.bufferExchange.invalidStartExchange.message;",
        });
      else if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
        alertText = formatMessage({
          id: "toast.autoProfile.finalVolumeAutoRecovery.error",
        });
      }

      break;
    }
    default:
      break;
  }

  if (!currentProfileParams[APPDATA.KEY.ConicalVolume]) {
    alertText = formatMessage({
      id: "toast.autoProfile.leftConicalRequired.message",
    });
    // NOTE: the behavior should input he footer setup first
    warningList = [];
  } else if (!currentProfileParams[APPDATA.KEY.MembraneType]) {
    alertText = formatMessage({
      id: "toast.autoProfile.membraneTypeRequired.message",
    });
    // NOTE: the behavior should input he footer setup first
    warningList = [];
  } else if (!currentProfileParams[APPDATA.KEY.MembraneCutOffSize]) {
    alertText = formatMessage({ id: "toast.autoProfile.mwcoRequired.message" });
    // NOTE: the behavior should input he footer setup first
    warningList = [];
  }

  let totalStartingVolume = startingVolume;
  if (autoProfileSetupMode === CONC_TWO_TUBES) {
    totalStartingVolume = startingVolume + startingVolume2ndTube;
  }

  if (autoRecovery) {
    if (
      finalVolume <
        AutoProfileConstants.SAFETY_WARNING_THRESHOLD_FINAL_VOL_WITH_AUTO_RECOVERY &&
      totalStartingVolume <=
        AutoProfileConstants.SAFETY_WARNING_THRESHOLD_STARTING_VOL_WITH_AUTO_RECOVERY
    ) {
      isShowSafetyThresholdWarning = true;
    } else if (
      finalVolume >=
      AutoProfileConstants.SAFETY_WARNING_THRESHOLD_FINAL_VOL_WITH_AUTO_RECOVERY
    ) {
      isShowSafetyThresholdWarning = false;
    }
  } else {
    isShowSafetyThresholdWarning =
      safetyThreshold >
        AutoProfileConstants.SAFETY_THRESHOLD_POP_UP_VALUE_ZERO &&
      finalVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE &&
      totalStartingVolume - finalVolume <= safetyThreshold;
  }

  if (warningList.length || alertText) {
    batch(() => {
      if (warningList.length)
        dispatch(setInvalidAutoProfileParams(warningList));

      if (alertText)
        dispatch(
          showAlert({
            alertShow: true,
            alertText,
            alertStyle,
          })
        );
    });
    return;
  }

  // legacy code
  // if (
  //   moreThan50ml === APPDATA.ENUM.MORE_THAN_50_ML.ON ||
  //   diafiltrationMode !== APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.NONE
  // ) {
  //   doRunAutoProfile();
  // }

  if (isShowSafetyThresholdWarning) {
    const popUpButton = [
      {
        id: APPDATA.CONTINUE,
        isPrimaryButton: true,
        onClick: () => {
          batch(() => {
            dispatch(hidePopUp());
            dispatch(doRunAutoProfile());
          });
        },
        label: formatMessage({
          id: "modal.safetyThresholdWarning.primaryButton",
        }),
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: () => dispatch(hidePopUp()),
        label: formatMessage({
          id: "modal.safetyThresholdWarning.secondaryButton",
        }),
      },
    ];

    dispatch(
      showPopUp({
        popUpTitle: formatMessage({ id: "modal.safetyThresholdWarning.title" }),
        popUpText: formatMessage({
          id: "modal.safetyThresholdWarning.message",
        }),
        popUpQuestion: undefined,
        popUpButton,
      })
    );
    return;
  }

  dispatch(doRunAutoProfile());
};

export const validateAutoProfileScheduledParams =
  (data) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { autoProfileSetupMode, currentProfileParams, advSetupSelected } =
      setupStore;
    const conicalVolume = parseFloat(data[APPDATA.KEY.ConicalVolume]);
    const startingVolume = parseFloat(data[APPDATA.KEY.StartingVolume]);
    const startingVolume2ndTube = parseFloat(
      data[APPDATA.KEY.StartingVolumeFor2ndTube]
    );
    const finalVolume = parseFloat(data[APPDATA.KEY.FinalVolume]);
    const volumeToStartAt = parseFloat(data[APPDATA.KEY.VolumeToStartAt]);
    const stepSizeVolume = parseFloat(data[APPDATA.KEY.StepSizeVolume]);
    const bufferVolumeToUse = parseFloat(data[APPDATA.KEY.BufferVolumeToUse]);

    const autoRecovery =
      advSetupSelected?.ConfigAdvSetup?.GeneralAdvSetup?.AutoRecoveryFlag;

    let alertText = "";
    let warningList = [];

    switch (autoProfileSetupMode) {
      case CONCENTRATE: {
        const invalidFields = getInvalidFieldConc(
          startingVolume,
          finalVolume,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);
        if (
          warningList.length &&
          !(warningList.length === 1 && warningList[0] === AUTO_RECOVERY)
        ) {
          alertText = formatMessage({
            id: "toast.autoProfile.invalidStartingAndFinalVol.message",
          });
        }

        break;
      }
      case CONC_TWO_TUBES: {
        const invalidFields = getInvalidFieldConc2Tubes(
          startingVolume,
          startingVolume2ndTube,
          finalVolume,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);

        if (
          warningList.length &&
          !(warningList.length === 1 && warningList[0] === AUTO_RECOVERY)
        ) {
          alertText = formatMessage({
            id: "toast.autoProfile.concentrateTwoTubes.invalidStartingAndFinalVol.message",
          });
        }

        break;
      }
      case BUFFER_EXCHANGE: {
        const invalidFields = getInvalidFieldBufferExchange(
          startingVolume,
          finalVolume,
          volumeToStartAt,
          stepSizeVolume,
          bufferVolumeToUse,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);

        if (
          warningList.some((e) => [STARTING_VOLUME, FINAL_VOLUME].includes(e))
        )
          alertText = formatMessage({
            id: "toast.autoProfile.invalidStartingAndFinalVol.message",
          });
        else if (
          warningList.some((e) => [STEP_SIZE, EXCHANGE_SIZE].includes(e))
        )
          alertText = formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStepSize.message",
          });
        else if (warningList.some((e) => [VOLUME_TO_START_AT].includes(e)))
          alertText = formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStartExchange.message;",
          });

        break;
      }
      default:
        break;
    }

    if (!currentProfileParams[APPDATA.KEY.ConicalVolume]) {
      alertText = formatMessage({
        id: "toast.autoProfile.leftConicalRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    } else if (!currentProfileParams[APPDATA.KEY.MembraneType]) {
      alertText = formatMessage({
        id: "toast.autoProfile.membraneTypeRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    } else if (!currentProfileParams[APPDATA.KEY.MembraneCutOffSize]) {
      alertText = formatMessage({
        id: "toast.autoProfile.mwcoRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    }

    const isOnlyAutoRecovery =
      warningList.length === 1 && warningList[0] === AUTO_RECOVERY;

    if ((warningList.length && !isOnlyAutoRecovery) || alertText) {
      batch(() => {
        if (warningList.length);

        dispatch(setInvalidAutoProfileParams(warningList));

        if (alertText)
          dispatch(
            showAlert({
              alertShow: true,
              alertText,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING,
            })
          );
      });
      return;
    }

    dispatch(doRunAutoProfile());
  };

export const validateAutoProfileParamsBeforeSchedule =
  () => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const {
      autoProfileSetupMode,
      currentProfileParams,
      currentAdvSetupParams,
      advSetupSelected,
    } = setupStore;
    const conicalVolume = parseFloat(
      currentProfileParams[APPDATA.KEY.ConicalVolume]
    );
    const startingVolume = parseFloat(
      currentProfileParams[APPDATA.KEY.StartingVolume]
    );
    const startingVolume2ndTube = parseFloat(
      currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube]
    );
    const finalVolume = parseFloat(
      currentProfileParams[APPDATA.KEY.FinalVolume]
    );
    const volumeToStartAt = parseFloat(
      currentProfileParams[APPDATA.KEY.VolumeToStartAt]
    );
    const stepSizeVolume = parseFloat(
      currentProfileParams[APPDATA.KEY.StepSizeVolume]
    );
    const bufferVolumeToUse = parseFloat(
      currentProfileParams[APPDATA.KEY.BufferVolumeToUse]
    );
    const safetyThreshold = parseFloat(
      currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup
        ?.ManualControlThreshold
    );

    const autoRecovery =
      advSetupSelected?.ConfigAdvSetup?.GeneralAdvSetup?.AutoRecoveryFlag;

    let alertText = "";
    let alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_WARNING;
    let warningList = [];
    let isShowSafetyThresholdWarning = false;

    switch (autoProfileSetupMode) {
      case CONCENTRATE: {
        const invalidFields = getInvalidFieldConc(
          startingVolume,
          finalVolume,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);

        if (warningList.length) {
          if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
            alertText = formatMessage({
              id: "toast.autoProfile.finalVolumeAutoRecovery.error",
            });
            alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
          } else {
            alertText = formatMessage({
              id: "toast.autoProfile.invalidStartingAndFinalVol.message",
            });
          }
        }

        break;
      }
      case CONC_TWO_TUBES: {
        const invalidFields = getInvalidFieldConc2Tubes(
          startingVolume,
          startingVolume2ndTube,
          finalVolume,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);

        if (warningList.length) {
          if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
            alertText = formatMessage({
              id: "toast.autoProfile.finalVolumeAutoRecovery.error",
            });
            alertStyle = APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER;
          } else {
            alertText = formatMessage({
              id: "toast.autoProfile.concentrateTwoTubes.invalidStartingAndFinalVol.message",
            });
          }
        }

        break;
      }
      case BUFFER_EXCHANGE: {
        const invalidFields = getInvalidFieldBufferExchange(
          startingVolume,
          finalVolume,
          volumeToStartAt,
          stepSizeVolume,
          bufferVolumeToUse,
          autoRecovery,
          conicalVolume
        );

        warningList = warningList.concat(invalidFields);

        if (
          warningList.some((e) => [STARTING_VOLUME, FINAL_VOLUME].includes(e))
        )
          alertText = formatMessage({
            id: "toast.autoProfile.invalidStartingAndFinalVol.message",
          });
        else if (
          warningList.some((e) => [STEP_SIZE, EXCHANGE_SIZE].includes(e))
        )
          alertText = formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStepSize.message",
          });
        else if (warningList.some((e) => [VOLUME_TO_START_AT].includes(e)))
          alertText = formatMessage({
            id: "toast.autoProfile.bufferExchange.invalidStartExchange.message;",
          });
        else if (warningList.length === 1 && warningList[0] === AUTO_RECOVERY) {
          alertText = formatMessage({
            id: "toast.autoProfile.finalVolumeAutoRecovery.error",
          });
        }
        break;
      }
      default:
        break;
    }

    if (!currentProfileParams[APPDATA.KEY.ConicalVolume]) {
      alertText = formatMessage({
        id: "toast.autoProfile.leftConicalRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    } else if (!currentProfileParams[APPDATA.KEY.MembraneType]) {
      alertText = formatMessage({
        id: "toast.autoProfile.membraneTypeRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    } else if (!currentProfileParams[APPDATA.KEY.MembraneCutOffSize]) {
      alertText = formatMessage({
        id: "toast.autoProfile.mwcoRequired.message",
      });
      // NOTE: the behavior should input he footer setup first
      warningList = [];
    }

    let totalStartingVolume = startingVolume;
    if (autoProfileSetupMode === CONC_TWO_TUBES) {
      totalStartingVolume = startingVolume + startingVolume2ndTube;
    }

    if (autoRecovery) {
      if (
        finalVolume <
          AutoProfileConstants.SAFETY_WARNING_THRESHOLD_FINAL_VOL_WITH_AUTO_RECOVERY &&
        totalStartingVolume <=
          AutoProfileConstants.SAFETY_WARNING_THRESHOLD_STARTING_VOL_WITH_AUTO_RECOVERY
      ) {
        isShowSafetyThresholdWarning = true;
      } else if (
        finalVolume >=
        AutoProfileConstants.SAFETY_WARNING_THRESHOLD_FINAL_VOL_WITH_AUTO_RECOVERY
      ) {
        isShowSafetyThresholdWarning = false;
      }
    } else {
      isShowSafetyThresholdWarning =
        safetyThreshold >
          AutoProfileConstants.SAFETY_THRESHOLD_POP_UP_VALUE_ZERO &&
        finalVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE &&
        totalStartingVolume - finalVolume <= safetyThreshold;
    }

    if (warningList.length || alertText) {
      batch(() => {
        if (warningList.length)
          dispatch(setInvalidAutoProfileParams(warningList));

        if (alertText)
          dispatch(
            showAlert({
              alertShow: true,
              alertText,
              alertStyle,
            })
          );
      });
      return;
    }

    if (isShowSafetyThresholdWarning) {
      const popUpButton = [
        {
          id: APPDATA.CONTINUE,
          isPrimaryButton: true,
          onClick: () => {
            batch(() => {
              dispatch(hidePopUp());
              dispatch(showScheduleRunModal());
            });
          },
          label: formatMessage({
            id: "modal.safetyThresholdWarning.primaryButton",
          }),
        },
        {
          id: APPDATA.CANCEL,
          isPrimaryButton: false,
          onClick: () => dispatch(hidePopUp()),
          label: formatMessage({
            id: "modal.safetyThresholdWarning.secondaryButton",
          }),
        },
      ];

      dispatch(
        showPopUp({
          popUpTitle: formatMessage({
            id: "modal.safetyThresholdWarning.title",
          }),
          popUpText: formatMessage({
            id: "modal.safetyThresholdWarning.message",
          }),
          popUpQuestion: undefined,
          popUpButton,
        })
      );
      return;
    }

    dispatch(showScheduleRunModal());
  };

export const doValidateAndSetAutoProfile =
  (startDate, relativeTime, scheduleType) => (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentAdvSetupParams, invalidAutoProfileParams } = setupStore;
    const param = {
      isRunLater: true,
      startDate,
      relativeTime,
      scheduleType,
    };
    const bus = eventBusObject();

    // setup adv setup
    let advSetup = {
      id: APPDATA.EMPTY_FIELD,
      name: "DEFAULT SETUP",
    };

    if (currentAdvSetupParams)
      advSetup = {
        id: currentAdvSetupParams.Id,
        name: currentAdvSetupParams.Name,
      };

    batch(() => {
      // NOTE: remove all invalid fields except current buffer volume on buffer exchange
      dispatch(
        setInvalidAutoProfileParams(
          invalidAutoProfileParams.filter((e) =>
            [CURRENT_BUFFER_VOLUME].includes(e)
          )
        )
      );
      dispatch(updateProfileAdvSetupParam(advSetup.id, advSetup.name));
      dispatch(
        updateManualControlState(
          MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL
        )
      );
      // Pre check the consumables before set the schedule profile
      bus.publish(PreCheckRunningProfileEvent.RUN_PRE_CHECK, param);
    });
  };

export function changeMethodAutoProfile(value, isResetState = true) {
  return (dispatch) => {
    let params = {};
    batch(() => {
      let isMoreThan50 = false;

      switch (value) {
        case APPDATA.FIELD_NAME.CONCENTRATE:
          isMoreThan50 = APPDATA.ENUM.MORE_THAN_50_ML.OFF;

          dispatch(updateCurrentIsMoreThan50ml(isMoreThan50));
          dispatch(
            updateAutoProfileDiafiltrationMode(
              APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.NONE
            )
          );
          dispatch(
            bulkUpdateProfileParamByName({
              MoreThan50ml: isMoreThan50,
              DiafiltrationMode: APPDATA.FIELD_NAME.NONE_DIAFILTRATION,
              // StartingVolume: data.startVolume,
              // FinalVolume: data.finalVolume,
              // StartingConcentration: data.startConcentration,
              // EstimatedFinalConcentration: data.finalConcentration,
            })
          );

          break;
        case APPDATA.FIELD_NAME.CONC_TWO_TUBES:
          isMoreThan50 = APPDATA.ENUM.MORE_THAN_50_ML.ON;

          dispatch(updateCurrentIsMoreThan50ml(isMoreThan50));
          dispatch(
            updateAutoProfileDiafiltrationMode(
              APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.NONE
            )
          );
          dispatch(
            bulkUpdateProfileParamByName({
              MoreThan50ml: isMoreThan50,
              // FinalVolume: data.finalVolume,
              // StartingConcentration: data.startConcentration,
              // EstimatedFinalConcentration: data.finalConcentration,
              DiafiltrationMode: APPDATA.FIELD_NAME.NONE_DIAFILTRATION,
            })
          );

          // if (
          //   !isEmptyFieldValue(data.startVolume) &&
          //   !isEmptyFieldValue(data.finalConcentration) &&
          //   !isEmptyFieldValue(data.startConcentration) &&
          //   !isEmptyFieldValue(data.startVolume02)
          // ) {
          //   dispatch(setStartingLeftVol(data.startVolume));

          //   const totalStartingVolume =
          //     parseFloat(data.startVolume) + parseFloat(data.startVolume02);
          //   const newFinalVolume = this.automaticCountFinalVolume(
          //     totalStartingVolume,
          //     data.finalConcentration,
          //     data.startConcentration,
          //     value,
          //   );
          //   if (newFinalVolume < AutoProfileConstants.MIN_VALUE_FINAL_VOL) {
          //     this.impossibleSetEstimateFinalConcentration(
          //       AutoProfileConstants.MIN_VALUE_FINAL_VOL,
          //       totalStartingVolume,
          //       value,
          //     );
          //   } else if (newFinalVolume > AutoProfileConstants.MAX_VALUE_FINAL_VOL) {
          //     this.impossibleSetEstimateFinalConcentration(
          //       AutoProfileConstants.MAX_VALUE_FINAL_VOL,
          //       totalStartingVolume,
          //       value,
          //     );
          //   }
          // }
          break;
        case APPDATA.FIELD_NAME.BUFFER_EXCHANGE:
          isMoreThan50 = APPDATA.ENUM.MORE_THAN_50_ML.OFF;

          dispatch(updateCurrentIsMoreThan50ml(isMoreThan50));
          dispatch(
            updateAutoProfileDiafiltrationMode(
              APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.CONTINUOUS
            )
          );
          dispatch(
            bulkUpdateProfileParamByName({
              MoreThan50ml: isMoreThan50,
              // StartingVolume: data.startVolume,
              // FinalVolume: data.finalVolume,
              // StartingConcentration: data.startConcentration,
              // EstimatedFinalConcentration: data.finalConcentration,
              DiafiltrationMode: APPDATA.FIELD_NAME.CONTINUOUS_DIAFILTRATION,
            })
          );

          break;
        default:
          break;
      }

      dispatch(updateAutoProfileSetupMode(value));
      if (isResetState) {
        dispatch(removeInvalidAutoProfileParam());
        params = dispatch(resetAutoProfileParams(false));
      }
    });

    return params;
  };
}

export function changeConical(value) {
  return (dispatch) => {
    batch(() => {
      if (parseFloat(value) === CONICAL_VOLUME.FIFTY) {
        dispatch(removeInvalidAutoProfileParam());
      }
      dispatch(updateProfileParamByName(ConicalVolume, value));
    });
  };
}

export function resetAutoProfileParams(isResetAll = true) {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const {
      defaultConfigAdvSetupParams,
      autoProfileSetupMode,
      currentProfileParams,
      deviceVersion,
    } = setupStore;

    let moreThan50 = APPDATA.ENUM.MORE_THAN_50_ML.OFF;
    if (autoProfileSetupMode === APPDATA.FIELD_NAME.CONC_TWO_TUBES) {
      moreThan50 = APPDATA.ENUM.MORE_THAN_50_ML.ON;
    }

    let conicalVolume = currentProfileParams[APPDATA.KEY.ConicalVolume];
    let membraneCutOffSize =
      currentProfileParams[APPDATA.KEY.MembraneCutOffSize];
    let membraneType = currentProfileParams[APPDATA.KEY.MembraneType];
    if (isResetAll) {
      conicalVolume =
        deviceVersion !== VERSION_2
          ? undefined
          : ConicalOptionsV2[0].value.toString();
      membraneCutOffSize = undefined;
      membraneType = undefined;
    }

    const defaultCurrentProfileParams = {
      [APPDATA.KEY.StartingVolume]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.StartingConcentration]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.FinalVolume]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.EstimatedFinalConcentration]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.VolumeToStartAt]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.BufferVolumeToUse]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.DiafiltrationMode]:
        currentProfileParams[APPDATA.KEY.DiafiltrationMode],
      [APPDATA.KEY.ExchangeStepSize]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.StepSizeVolume]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.TotalBufferVolumeToUse]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.ChipValve]: APPDATA.ENUM.TOTAL_VALVE_IN_CHIP.Six,
      [APPDATA.KEY.MoreThan50ml]: moreThan50,
      [APPDATA.KEY.StartingVolumeFor2ndTube]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.IdAdvSetup]: APPDATA.EMPTY_FIELD,
      [APPDATA.KEY.MembraneCutOffSize]: membraneCutOffSize,
      [APPDATA.KEY.MembraneType]: membraneType,
      [APPDATA.KEY.ConicalVolume]: conicalVolume,
    };

    const newConfigParam = {
      [AutoProfileSetupMode[0]]: objMapper(
        defaultCurrentProfileParams,
        ConcentrateStateMapper
      ),
      [AutoProfileSetupMode[1]]: objMapper(
        defaultCurrentProfileParams,
        Concentrate2TubesStateMapper
      ),
      [AutoProfileSetupMode[2]]: {
        startVolume: APPDATA.EMPTY_FIELD,
        finalVolume: APPDATA.EMPTY_FIELD,
        startConcentration: APPDATA.EMPTY_FIELD,
        finalConcentration: APPDATA.EMPTY_FIELD,
      },
    };

    batch(() => {
      if (isResetAll)
        dispatch(updateCurrentAdvSetupParam(defaultConfigAdvSetupParams));
      dispatch(setInvalidAutoProfileParams([]));
      dispatch(updateCurrentProfileParam(defaultCurrentProfileParams));
      dispatch(isCompleteFill(false));
    });

    return newConfigParam;
  };
}

export const resetMWCO = () => (dispatch, getState) => {
  const { setupStore } = { ...getState() };
  const { currentProfileParams } = setupStore;
  const _currentProfileParams = { ...currentProfileParams };
  _currentProfileParams[APPDATA.KEY.MembraneCutOffSize] = undefined;
  dispatch(updateCurrentProfileParam(_currentProfileParams));
};

// #endregion

// #region Buffer Exchange

function handleContinueExchangeVolumeModal() {
  return (dispatch) => {
    batch(() => {
      dispatch(hidePopUp());
    });
  };
}

function handleCancelExchangeVolumeModal(
  callback = () => {},
  isCancelCurrentBuffer = false
) {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentProfileParams } = setupStore;

    let numpadObj = {
      modalHeader: APPDATA.FIELD_NAME.EXCHANGE_VOLUME,
      value: currentProfileParams[APPDATA.KEY.BufferVolumeToUse],
      callback,
      maxValue: APPDATA.CONFIGURATION.VOLUME_SENSOR.MAX_EXCHANGE_VOLUME,
      minValue: APPDATA.CONFIGURATION.VOLUME_SENSOR.MIN_VALUE,
      maxDigitAfterDecimal:
        APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY,
      incrementValue: APPDATA.CONFIGURATION.VOLUME_SENSOR.INCREMENT_VALUE,
      unit: APPDATA.UNIT.ml,
      info: undefined,
    };

    if (isCancelCurrentBuffer)
      numpadObj = {
        ...numpadObj,
        modalHeader: APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME,
        value: currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse],
        maxValue: APPDATA.CONFIGURATION.VOLUME_SENSOR.MAX_VALUE,
        minValue:
          APPDATA.CONFIGURATION.VOLUME_SENSOR.MIN_VALUE +
          CURRENT_BUFFER_EXCHANGE_VOL_THRESHOLD,
      };

    batch(() => {
      dispatch(showModal({ ...numpadObj }));
      dispatch(hidePopUp());
    });
  };
}

export function showExchangeVolumeModal(
  _currBufferVol,
  _bufferVol,
  callback = () => {},
  isCancelCurrentBuffer = false
) {
  return (dispatch) => {
    const currBufferVol = +parseFloat(_currBufferVol).toFixed(
      APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY
    );
    const bufferVol = +parseFloat(_bufferVol).toFixed(
      APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY
    );
    const thresholdVol = APPDATA.BUFFER_THRESHOLD;
    const popUpButton = [
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: () =>
          dispatch(
            handleCancelExchangeVolumeModal(callback, isCancelCurrentBuffer)
          ),
        label: formatMessage({ id: "modal.exchangeVolume.secondaryButton" }),
      },
      {
        id: APPDATA.CONTINUE,
        isPrimaryButton: true,
        onClick: () => dispatch(handleContinueExchangeVolumeModal()),
        label: formatMessage({ id: "modal.exchangeVolume.primaryButton" }),
        disabled: false,
      },
    ];

    dispatch(
      showPopUp({
        popUpTitle: formatMessage({ id: "modal.exchangeVolume.title" }),
        popUpText: (
          // Replace the formatMessage with a custom function to format the message for device V2 (older chrome versions)
          <ul>
            {formatMessage(
              { id: "modal.exchangeVolume.message" },
              {
                currBufferVol,
                bufferVol,
                thresholdVol,
              }
            )
              .split("\n")
              .map((item) => {
                const matches = [...item.matchAll(/<li>(.*?)<\/li>/g)];
                const content =
                  matches.length > 0
                    ? matches.map((match) => <li>{match[1]}</li>)
                    : item;

                return (
                  <>
                    <br />
                    {content}
                  </>
                );
              })}
          </ul>
        ),
        popUpButton,
        popUpHideCloseButton: true,
      })
    );
  };
}
// #endregion

// #region Pause To Refill

export function showPauseToRefillModal() {
  return (dispatch) => {
    dispatch(setShowPauseToRefillModal(true));
  };
}

export function hidePauseToRefillModal() {
  return (dispatch) => {
    dispatch(setShowPauseToRefillModal(false));
  };
}

export function showScheduleRunModal() {
  return (dispatch) => {
    dispatch(setShowScheduleRunModal(true));
  };
}

export function hideScheduleRunModal() {
  return (dispatch) => {
    dispatch(setShowScheduleRunModal(false));
  };
}

export function proceedContinueProfilePause() {
  return async (dispatch) => {
    try {
      await dispatch(resumeAutoProfile());
      dispatch(hidePauseToRefillModal());
    } catch (error) {
      console.log("proceedContinueProfilePause error", error);
    }
  };
}

export function proceedRefillBufferPause() {
  return (dispatch) => {
    batch(() => {
      dispatch(updateShowRefillBuffer(true));
      dispatch(hidePauseToRefillModal());
    });
  };
}

export function pauseAutoProfile() {
  return async (dispatch, getState) => {
    const { manualControlStore, setupStore } = { ...getState() };
    const { isPCRunning, isPCPaused } = setupStore;
    const { StatusManualControl } = manualControlStore;
    const { IsManualControlEnable } = StatusManualControl;

    try {
      if (IsManualControlEnable === "true") {
        dispatch(showLoading(false));
        dispatch(startManualControl());
      } else if (isPCRunning && !isPCPaused) {
        dispatch(setIsPauseHandled(true));

        await postPauseConcentrator();
        dispatch(showLoading(false));
      }
    } catch (error) {
      console.log("pauseAutoProfile error", error);
      dispatch(showLoading(false));
    }
  };
}

export function resumeAutoProfile() {
  return async (dispatch, getState) => {
    const { manualControlStore, setupStore } = { ...getState() };
    const { isPCRunning, isPCPaused } = setupStore;
    const { StatusManualControl } = manualControlStore;
    const { IsManualControlEnable } = StatusManualControl;

    try {
      dispatch(setIsPauseHandled(false));

      if (isPCRunning && isPCPaused) {
        await postResumeConcentrator();
      } else if (IsManualControlEnable === "true") {
        dispatch(startManualControl());
      }
    } catch (error) {
      console.log("resumeAutoProfile error", error);
      // dispatch(showLoading(false));
      throw error;
    }
  };
}

// #endregion

// #region Recovery Of Liquid
export function finishROLAutoProfile(recoveryAction) {
  return async (dispatch) => {
    const bus = eventBusObject();
    const paramRecovery = {
      RecoveryType: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
      NumberOfPumps: 0,
    };

    switch (recoveryAction) {
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR:
      case RecoveryOfLiquidAction.STOP_NORMAL_PROCESS:
        dispatch(PostStopNormalConcentration(paramRecovery));
        break;
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP:
        await postStopConcentrator(StopEnum.NONE);
        break;
      case RecoveryOfLiquidAction.START_RECOVERY_OF_LIQUID:
      case RecoveryOfLiquidAction.STOP_MANUAL_CONTROL:
      default:
        dispatch(PostRecoveryOfLiquidManual(paramRecovery));
        break;
    }

    batch(() => {
      dispatch(isFinishRecovery(true));
      dispatch(isShowRecoveryLoading(true));
      dispatch(IsFromStopProfile(false));
      dispatch(IsRecoveryClicked(false));
      dispatch(IsRecoveryFromErrorProfile(false));
      dispatch(
        updateLoading({
          showLoading: true,
          loadingText: "Loading...",
        })
      );
      bus.publish(RecoveryOfLiquidEvent.HIDE_POP_UP);
    });
  };
}

export function recoverROLAutoProfile(
  recoveryAction,
  selectedRecoveryOfLiquid,
  numberOfPumps
) {
  return async (dispatch) => {
    const bus = eventBusObject();
    let selectedROL = APPDATA.ENUM.RECOVERY_OF_LIQUID.None;
    let numberPumps = 0;
    dispatch(showLoading(true));
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: "",
      })
    );
    switch (selectedRecoveryOfLiquid) {
      case RecoveryOfLiquidMode.BUFFER:
        selectedROL = APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer;
        numberPumps = Math.round(
          numberOfPumps / APPDATA.CONFIGURATION.VOLUME_BUFFER_RECOVERY.MIN_VALUE
        );
        break;
      case RecoveryOfLiquidMode.AIR:
        selectedROL = APPDATA.ENUM.RECOVERY_OF_LIQUID.Air;
        numberPumps = parseInt(
          numberOfPumps / APPDATA.CONFIGURATION.VOLUME_AIR_RECOVERY.MIN_VALUE,
          10
        );
        break;
      case RecoveryOfLiquidMode.AIR_BUFFER:
        selectedROL = APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer;
        numberPumps = parseInt(
          numberOfPumps / APPDATA.CONFIGURATION.VOLUME_AIR_RECOVERY.MIN_VALUE,
          10
        );
        break;
      default:
        selectedROL = APPDATA.ENUM.RECOVERY_OF_LIQUID.Air;
        numberPumps = parseInt(
          numberOfPumps / APPDATA.CONFIGURATION.VOLUME_AIR_RECOVERY.MIN_VALUE,
          10
        );
        break;
    }
    const paramRecovery = {
      RecoveryType: selectedROL,
      NumberOfPumps: numberPumps,
    };
    switch (recoveryAction) {
      case RecoveryOfLiquidAction.STOP_NORMAL_PROCESS:
        dispatch(PostStopNormalConcentration(paramRecovery));
        break;
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR:
      case RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP:
      case RecoveryOfLiquidAction.START_RECOVERY_OF_LIQUID:
      case RecoveryOfLiquidAction.STOP_MANUAL_CONTROL:
      default:
        dispatch(PostRecoveryOfLiquidManual(paramRecovery));
        break;
    }

    batch(() => {
      dispatch(isFinishRecovery(false));
      dispatch(isShowRecoveryLoading(true));
      dispatch(IsRecoveryClicked(true));
      bus.publish(RecoveryOfLiquidEvent.HIDE_POP_UP);
    });
  };
}

export function cancelROLAutoProfile(recoveryAction) {
  return async (dispatch, getState) => {
    const { manualControlStore, setupStore } = { ...getState() };
    const { StatusManualControl } = manualControlStore;
    const { profileRunning } = setupStore;
    const { Config } = profileRunning;
    const { IsManualControlEnable, IsPrimeCompleted } = StatusManualControl;
    const bus = eventBusObject();

    const isRecoveryFromStop = [
      RecoveryOfLiquidAction.RECOVERY_FROM_STOP_POPUP,
      RecoveryOfLiquidAction.RECOVERY_FROM_STOP_ERROR,
    ].includes(recoveryAction);

    if (isRecoveryFromStop) {
      batch(() => {
        bus.publish(StopEvent.PAUSE_PROCESS, {
          disableManualControl:
            IsPrimeCompleted === "false" ||
            Number(Config.FinalVolume) >= RECOVERY_FINAL_VOL_THRESHOLD,
        });
        dispatch(IsFromStopProfile(false));
        dispatch(IsRecoveryClicked(false));
      });
    } else if (IsManualControlEnable) {
      batch(() => {
        dispatch(IsShowManualControlPopUp(true));
        dispatch(IsShowManualControlAvailablePopUp(true));
        dispatch(IsRecoveryClicked(false));
        bus.publish(RecoveryOfLiquidEvent.HIDE_POP_UP);
      });
    } else {
      dispatch(isFinishRecovery(false));
      if (String(IsManualControlEnable) === "false") {
        bus.publish(ManualControlEventTopMenu.EnableManualControlTopMenu, "");
      }
      dispatch(PostStopRecovery());
      bus.publish(RecoveryOfLiquidEvent.HIDE_POP_UP);
    }
  };
}
// #endregion

// #region RUNTIME

export function startConcentrating(deviceElementCheckList) {
  return async (dispatch, getState) => {
    try {
      const { setupStore } = { ...getState() };
      const { currentProfileParams, autoProfileSetupMode } = setupStore;

      let profileValue;

      if (
        currentProfileParams[APPDATA.KEY.DiafiltrationMode] ===
        APPDATA.FIELD_NAME.NONE_DIAFILTRATION
      ) {
        if (currentProfileParams[APPDATA.KEY.MoreThan50ml] === "true") {
          profileValue = {
            ProteinVolume: parseFloat(
              currentProfileParams[APPDATA.KEY.StartingVolume]
            ),
            BufferVolume: parseFloat(
              currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube]
            ),
          };
        } else {
          profileValue = {
            ProteinVolume: parseFloat(
              currentProfileParams[APPDATA.KEY.StartingVolume]
            ),
          };
        }
      } else {
        profileValue = {
          ProteinVolume: parseFloat(
            currentProfileParams[APPDATA.KEY.StartingVolume]
          ),
          BufferVolume: parseFloat(
            currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse]
          ),
        };
      }

      await postNewStartConcentrator(
        profileValue.ProteinVolume,
        profileValue.BufferVolume,
        deviceElementCheckList,
        generateProfileConfigModel(currentProfileParams)
      );
      const response = await getStatus();

      let status = {};

      if (
        currentProfileParams[APPDATA.KEY.DiafiltrationMode] !==
        APPDATA.FIELD_NAME.NONE_DIAFILTRATION
      ) {
        const { data } = response;
        status = getAutoProfileUpdateStatusModel({
          ...data,
          [APPDATA.KEY.StartingVolume]: parseFloat(
            currentProfileParams[APPDATA.KEY.StartingVolume]
          ),
          [APPDATA.KEY.TotalBufferVolumeToUse]: parseFloat(
            currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse]
          ),
        });
      }

      let currentBuffer = "";
      let currentVolume = "";
      let requireRefill = "0";
      const startingVolume = parseNumberParam(
        currentProfileParams[APPDATA.KEY.StartingVolume]
      );
      const startingVolumeFor2ndTube = parseNumberParam(
        currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube]
      );
      const totalBufferVolumeToUse = parseNumberParam(
        currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse]
      );
      const bufferVolumeToUse = parseNumberParam(
        currentProfileParams[APPDATA.KEY.BufferVolumeToUse]
      );

      const bufferVolume = validateBufferVolBufferExchange(
        totalBufferVolumeToUse,
        bufferVolumeToUse
      );

      currentVolume = startingVolume;

      if (startingVolumeFor2ndTube || totalBufferVolumeToUse) {
        if (autoProfileSetupMode === CONC_TWO_TUBES)
          currentBuffer = startingVolumeFor2ndTube;
        else currentBuffer = totalBufferVolumeToUse;
      }

      if (
        autoProfileSetupMode === BUFFER_EXCHANGE &&
        totalBufferVolumeToUse < bufferVolume
      )
        requireRefill = bufferVolume;

      batch(() => {
        dispatch(setRunningMethod(autoProfileSetupMode));
        dispatch(updateStatus(status));
        dispatch(showLoading(false));

        // NOTE: handle initialize status state on running profile
        if (currentBuffer) dispatch(setCurrentBuffer(currentBuffer));
        if (currentVolume) dispatch(setCurrentVolume(currentVolume));
        if (requireRefill) dispatch(setRequireRefill(requireRefill));
      });
    } catch (error) {
      console.log("startConcentrating error", error);
    }
  };
}

export function stopAutoProfile() {
  return async (dispatch, getState) => {
    const { setupStore } = { ...getState() };

    const { profileRunning, isPCRunning, currentPCState, prevPCState } =
      setupStore;
    const { Config } = profileRunning;
    const { FinalVolume } = Config;
    const bus = eventBusObject();
    const FinalVol = Number(FinalVolume);

    if (!isPCRunning) {
      dispatch(showLoading(false));
      return;
    }

    if (
      (currentPCState === APPDATA.PC_PAUSED &&
        (prevPCState === APPDATA.PC_PRIMING_STATE ||
          prevPCState === APPDATA.PC_CONCENTRATING_STATE ||
          prevPCState === APPDATA.PC_DIAFILTRATING_STATE)) ||
      (currentPCState === APPDATA.PC_PREPARING_STATE &&
        (prevPCState === APPDATA.PC_PAUSED ||
          prevPCState === APPDATA.PC_PRIMING_STATE ||
          prevPCState === APPDATA.PC_CONCENTRATING_STATE ||
          prevPCState === APPDATA.PC_DIAFILTRATING_STATE)) ||
      currentPCState === APPDATA.PC_PRIMING_STATE ||
      currentPCState === APPDATA.PC_CONCENTRATING_STATE ||
      currentPCState === APPDATA.PC_DIAFILTRATING_STATE ||
      currentPCState === APPDATA.PC_FILL_MEMBRANE
    ) {
      const disableManualControl =
        currentPCState === APPDATA.PC_FILL_MEMBRANE ||
        currentPCState === APPDATA.PC_PRIMING_STATE ||
        (prevPCState === APPDATA.PC_PRIMING_STATE &&
          currentPCState === APPDATA.PC_PAUSED) ||
        FinalVol >= AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE;

      bus.publish(StopEvent.PAUSE_PROCESS, { disableManualControl });
    } else {
      dispatch(updateStoppingFromButton(true));
      dispatch(showLoading(true));
      dispatch(
        updateLoading({
          showLoading: true,
          loadingText: "Loading...",
          loadingButton1: {
            label: APPDATA.CLOSE,
            onClick: () => {
              dispatch(showLoading(false));
              postStopConcentrator(StopEnum.NONE);
            },
          },
        })
      );
      postStopConcentrator(StopEnum.NONE);
    }
  };
}
// #endregion

// #region MIXING

export function hideMixingAutoProfile() {
  return (dispatch) => {
    dispatch(
      updateLoading({
        showLoading: false,
      })
    );
  };
}

export function showMixingAutoProfile() {
  return (dispatch) => {
    dispatch(
      updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.MIXING_CYCLE.RUNNING,
        loadingButton1: {
          label: APPDATA.CANCEL,
          onClick: async () => {
            postStopMixingConcentrator().then(() =>
              dispatch(hideMixingAutoProfile())
            );
          },
        },
      })
    );
  };
}

// #endregion

// #region TOP MENU
export function changeDisabledRunButton(value = null) {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { isCompleteFill } = setupStore;

    // NOTE to toggling the state
    const disabled = value !== null ? value : !isCompleteFill;

    dispatch(setDisabledTopButtonProp(disabled));
  };
}
// #endregion

// #region General
export function initUpdateActiveMenu(value = null) {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentProfileParams } = setupStore;

    if (isAllAutoProfileParamFilled(currentProfileParams) === true) {
      dispatch(isCompleteFill(true));
    } else {
      dispatch(isCompleteFill(false));
    }
    dispatch(updateActiveMenu(value));
  };
}
// #endregion

// #region MANUAL CONTROL
export function startManualControlOnHold() {
  return (dispatch, getState) => {
    const { setupStore, manualControlStore } = { ...getState() };
    const { currentVolume } = setupStore;
    const { RequestPendingManualControl, IsHoldToRunActive } =
      manualControlStore;

    if (IsHoldToRunActive === false) {
      dispatch(updateIsHoldToRunActive(true));
      dispatch(updateManualControlStartVolume(currentVolume));

      if (!RequestPendingManualControl) {
        PostRequest(APPDATA.API.START_HOLD_TO_CONCENTRATE);
      }
    }
  };
}

export function stopManualControlOnHold() {
  return (dispatch, getState) => {
    const { manualControlStore } = { ...getState() };
    const { RequestPendingManualControl, IsHoldToRunActive } =
      manualControlStore;

    if (IsHoldToRunActive === true) {
      dispatch(updateIsHoldToRunActive(false));
      dispatch(updateManualControlStartVolume("0")); // reset value

      if (!RequestPendingManualControl) {
        PostRequest(APPDATA.API.STOP_HOLD_TO_CONCENTRATE);
      }
    }
  };
}
// #endregion

// #region ADV SETUP
export function openAdvSetup() {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentAdvSetupParams } = setupStore;

    if (currentAdvSetupParams) {
      const advSetupload = createNewJsonObject(currentAdvSetupParams);

      dispatch(setAdvSetupSelected(advSetupload));
    }

    navigateTo(APPDATA.ADVANCE_SETUP_EXPLORER);
  };
}
// #endregion

// #region DELAY PROFILE
export function addDelayProfile(startDate, deltaTime, scheduleType) {
  return async (dispatch, getState) => {
    const { setupStore, schedulerState, deviceInfoStore } = { ...getState() };
    const { currentProfileParams } = setupStore;
    const { scheduleId } = schedulerState;
    const { licenseExpiredDate } = deviceInfoStore;
    const licenseExpiredDateOnly = licenseExpiredDate.split(" ")[0];

    let profileValue;
    if (
      currentProfileParams[APPDATA.KEY.DiafiltrationMode] ===
      APPDATA.FIELD_NAME.NONE_DIAFILTRATION
    ) {
      if (currentProfileParams[APPDATA.KEY.MoreThan50ml] === "true") {
        profileValue = {
          ProteinVolume: parseFloat(
            currentProfileParams[APPDATA.KEY.StartingVolume]
          ),
          BufferVolume: parseFloat(
            currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube]
          ),
        };
      } else {
        profileValue = {
          ProteinVolume: parseFloat(
            currentProfileParams[APPDATA.KEY.StartingVolume]
          ),
        };
      }
    } else {
      profileValue = {
        ProteinVolume: parseFloat(
          currentProfileParams[APPDATA.KEY.StartingVolume]
        ),
        BufferVolume: parseFloat(
          currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse]
        ),
      };
    }

    const result = await postDelayProfile(
      startDate,
      deltaTime,
      scheduleType,
      profileValue.ProteinVolume,
      profileValue.BufferVolume,
      generateProfileConfigModel(currentProfileParams),
      scheduleId
    );

    if (result?.data === SCHEDULE_PROFILE.LICENSE_EXPIRED) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage(
            { id: "toast.schedulerProfile.licenseExpired" },
            { licenseExpiredDateOnly }
          ),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else if (result?.data === SCHEDULE_PROFILE.EDIT_NOT_ALLOWED) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.schedulerProfile.editNotAllowed",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else if (result?.data === SCHEDULE_PROFILE.TIME_HAS_PASSED) {
      dispatch(
        showAlert({
          alertShow: true,
          alertText: formatMessage({
            id: "toast.schedulerProfile.timeHasPassed",
          }),
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        })
      );
    } else if (result) {
      batch(() => {
        dispatch(hideScheduleRunModal());
        dispatch(setScheduleRun(true));
        dispatch(setScheduleId(result?.data?.Id));
        dispatch(setScheduleType(result?.data?.ScheduleType));
        dispatch(setStartTime(result?.data?.StartTime));
        dispatch(setDeltaTime(result?.data?.DeltaTime));
        dispatch(
          showAlert({
            alertShow: true,
            alertText: formatMessage({
              id: "toast.schedulerProfile.successSet",
            }),
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
          })
        );
      });
    }
  };
}

function removeScheduler() {
  return async (dispatch) => {
    const result = await removeDelayProfile();
    if (result) {
      batch(() => {
        dispatch(
          showAlert({
            alertShow: true,
            alertText: formatMessage({
              id: "toast.schedulerProfile.successRemove",
            }),
            alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_SUCCESS,
          })
        );
        dispatch(setScheduleRun(false));
        dispatch(setScheduleId(null));
        dispatch(setScheduleType(null));
        dispatch(setStartTime(""));
        dispatch(setDeltaTime(""));
      });
    }
  };
}

export function removeSchedulerConfirmation() {
  return async (dispatch, getState) => {
    const { schedulerState } = { ...getState() };
    const { startTime } = schedulerState;

    const parsedStartTime = `${moment(startTime).format("L")} ${moment(
      startTime
    ).format("LT")}`;
    const popUpButton = [
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: () => {
          batch(() => {
            dispatch(hidePopUp());
            dispatch(showScheduleRunModal());
          });
        },
        label: formatMessage({
          id: "modal.scheduleProfileRemove.secondaryButton",
        }),
      },
      {
        id: APPDATA.REMOVE,
        isPrimaryButton: true,
        onClick: () => {
          batch(() => {
            dispatch(hidePopUp());
            dispatch(removeScheduler());
          });
        },
        label: formatMessage({
          id: "modal.scheduleProfileRemove.primaryButton",
        }),
      },
    ];

    dispatch(hideScheduleRunModal());
    dispatch(
      showPopUp({
        popUpTitle: formatMessage({ id: "modal.scheduleProfileRemove.title" }),
        popUpText: formatMessage(
          { id: "modal.scheduleProfileRemove.message" },
          { parsedStartTime }
        ),
        popUpButton,
        popUpHideCloseButton: true,
      })
    );
  };
}

export function getDelayProfileState() {
  return async (dispatch) => {
    const result = await getDelayProfile();
    if (result?.data !== "NotFound") {
      const responseConfig = result?.data?.ProfileConfig;
      const membraneCutOffValue =
        MembraneCutOff[responseConfig?.MembraneCutOffSize] ||
        MembraneCutOff.CHIP_5_KDA;
      const currentProfileParameters = {
        StartingVolume: responseConfig?.StartingVolume,
        StartingConcentration: responseConfig?.StartingConcentration,
        EstimatedFinalConcentration:
          responseConfig?.EstimatedFinalConcentration,
        FinalVolume: responseConfig?.FinalVolume,
        BufferVolumeToUse: responseConfig?.BufferVolumeToUse,
        VolumeToStartAt: responseConfig?.VolumeToStartAt,
        DiafiltrationMode: responseConfig?.DiafiltrationMode,
        [APPDATA.KEY.ExchangeStepSize]: responseConfig?.ExchangeStepSize,
        [APPDATA.KEY.StepSizeVolume]: responseConfig?.StepSizeVolume,
        [APPDATA.KEY.MembraneCutOffSize]: membraneCutOffValue,
        [APPDATA.KEY.MembraneType]: String(responseConfig?.MembraneType),
        [APPDATA.KEY.ConicalVolume]: responseConfig?.ConicalVolume,
        [APPDATA.KEY.TotalBufferVolumeToUse]:
          responseConfig?.TotalBufferVolumeToUse,
        [APPDATA.KEY.ChipValve]: responseConfig?.ChipValve,
        [APPDATA.KEY.MoreThan50ml]: String(responseConfig?.MoreThan50ml),
        [APPDATA.KEY.StartingVolumeFor2ndTube]:
          responseConfig?.StartingVolumeFor2ndTube,
        [APPDATA.KEY.IdAdvSetup]: responseConfig?.IdAdvancedSetup,
        [APPDATA.KEY.AdvancedSetupName]: responseConfig?.AdvancedSetupName,
      };

      batch(() => {
        dispatch(setScheduleRun(true));
        dispatch(setScheduleId(result?.data?.Id));
        dispatch(setScheduleType(result?.data?.ScheduleType));
        dispatch(setStartTime(result?.data?.StartTime));
        dispatch(setDeltaTime(result?.data?.DeltaTime));
        dispatch(updateCurrentProfileParam(currentProfileParameters));
        dispatch(
          isCompleteFill(
            isAllAutoProfileParamFilled(currentProfileParameters) === true
          )
        );
      });
    } else {
      batch(() => {
        dispatch(setScheduleRun(false));
        dispatch(setScheduleId(null));
        dispatch(setScheduleType(null));
        dispatch(setStartTime(""));
      });
    }
  };
}

export function postHighVolumeBuffer() {
  return (dispatch, getState) => {
    const { setupStore } = { ...getState() };
    const { currentAdvSetupParams, autoProfileSetupMode } = setupStore;
    const highVolumeBuffer =
      currentAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][
        APPDATA.KEY.GeneralAdvSetup
      ][APPDATA.KEY.HighVolumeBufferFlag] || false;
    const isHiVolBufferExchange =
      highVolumeBuffer &&
      autoProfileSetupMode === APPDATA.AUTO_PROFILE_STATE.BUFFER_EXCHANGE;

    const params = { flag: isHiVolBufferExchange };
    PostRequest(APPDATA.API.SET_HIGH_VOLUME_BUFFER, params);
  };
}
// #endregion
